import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { InjectionDataBatch } from '../_models/injection-data-batch';
import { InjectionDataModel } from '../_models/injection-data-model';
import * as XLSX from 'xlsx-js-style';
import { InjectionDataRecord } from '../_models/injection-data-record';
import { InjectionPressureDataRecord } from '../_models/injection-pressure-data-record';
import { WellDetailsModel } from '../_models/well-details-model';

@Injectable({
  providedIn: 'root'
})
export class ExcelImportService {

  public currentExcelTemplateData: BehaviorSubject<InjectionDataBatch> = new BehaviorSubject<InjectionDataBatch>(null);

  private currentDataColumnsObj: any

  constructor() { }

  parseExcel = function (filePath) {

    var ret = new Promise((resolve, reject) => {
      var reader = new FileReader();

      var result = {

      };

      reader.onload = function (e) {
        var data = e.target.result;
        var workbook = XLSX.read(data, {
          type: 'binary'
        });

        workbook.SheetNames.forEach((sn) => {
          var json_object = XLSX.utils.sheet_to_json(workbook.Sheets[sn]);

          if (result[sn] == undefined || result[sn] == null) {
            result[sn] = [];
          }

          result[sn] = json_object;
        });

        resolve(result);
      };

      reader.onerror = function (ex) {

      };

      reader.readAsBinaryString(filePath)
    });

    return ret;
  }

  protected ExcelContentsToInjectionBatch(excelContents: any): InjectionDataBatch {
    var ret = new InjectionDataBatch();

    var h10Sheet = excelContents.Sheet1;

    var wellId = null;

    for (var i = 0; i < h10Sheet.length; i++) {

      var injRec;

      if (this.currentDataColumnsObj.controllerName == 'injection') {
        injRec = new InjectionDataRecord();
      }

      if (this.currentDataColumnsObj.controllerName == 'injectionPressure') {
        injRec = new InjectionPressureDataRecord();
      }

      var h10Row = h10Sheet[i];

      if (h10Row["BEGWellId"] != null) {
        wellId = h10Row["BEGWellId"];
      }

      injRec.WellId = wellId;
      this.currentDataColumnsObj.dataColumnsList.forEach(dataColumn => {
        injRec[dataColumn.key] = h10Row[dataColumn.label];
      });

      var date = new Date('' + h10Row["Date"]);
      var endDate = new Date('' + h10Row["EndDate"]);

      if (this.currentDataColumnsObj.controllerName == 'injection') {
        injRec.InjectionDate = date;
        injRec.InjectionEndDate = endDate;
      }

      if (this.currentDataColumnsObj.controllerName == 'injectionPressure') {
        injRec.MeasurementDate = date;
      }

      if (this.isValidDate(date) && this.isValidDate(endDate)) {
        ret.Injections.push(injRec);
      }
    }

    return ret;
  }

  protected isValidDate(date) {

    var ret = false;

    if (Object.prototype.toString.call(date) === "[object Date]") {
      // it is a date
      if (isNaN(date)) { // d.getTime() or d.valueOf() will also work
        // date object is not valid
      } else {
        // date object is valid
        ret = true;
      }
    } else {
      // not a date object
    }

    return ret;
  }

  public ImportExcelTemplateData(filePath: string, dataColumnsObj) {
    this.currentDataColumnsObj = dataColumnsObj;
    this.parseExcel(filePath).then((result) => {
      //Do something with the result.
      var injBatch;
      injBatch = this.ExcelContentsToInjectionBatch(result);

      this.currentExcelTemplateData.next(injBatch);
      
    },
      (err) => {
      });
  }

  //Generates an empty excel template to ease data entry for the user.
  public generateTemplate(wellDetails: WellDetailsModel, beginDate: Date, endDate: Date, dateMode: string, tableName: string, dataColumnslist: any[], combinedDataForms: any[]) {

    function formatDate(date) {
      let d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      let year =  '' + d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [month, day, year].join('/');
    }

    var beginDateString = formatDate(beginDate);
    var endDateString = formatDate(endDate);
    var uic = wellDetails.Uicnumber;

    var finalFilename = tableName + "_" + uic + "_" + beginDateString + "_" + endDateString + "_" + dateMode + ".xlsx";

    var workbook = XLSX.utils.book_new();

    var data = [];

    var curdate = new Date(beginDate);
    var firstRecord = true;
    var index = 0;
    while (index < combinedDataForms.length) {

      var curEndDate = null;

      if (dateMode == "monthly") {
        curEndDate = new Date(curdate);
        curEndDate.setMonth(curEndDate.getMonth() + 1);
        curEndDate.setDate(0);
      }
      else if (dateMode == "daily") {
        curEndDate = new Date(curdate);
      }

      var record = {};

      //Fill in the well header columns for every well, not just the first one.
      record["UIC Number"] = wellDetails.Uicnumber;
      record["Lease Name"] = wellDetails.LeaseName;
      record["Well Number"] = wellDetails.WellNumber;
      record["BEGWellId"] = wellDetails.Id;

      /*if (firstRecord) {
        record["UIC Number"] = wellDetails.Uicnumber;
        record["Lease Name"] = wellDetails.LeaseName;
        record["Well Number"] = wellDetails.WellNumber;
        record["BEGWellId"] = wellDetails.Id;
        firstRecord = false;
      }
      else {
        record["UIC Number"] = null;
        record["Lease Name"] = null;
        record["Well Number"] = null;
        record["BEGWellId"] = null;
      }*/

      

      var recordDateString = formatDate(curdate);
      var recordEndDateString = formatDate(curEndDate);

      record["Date"] = recordDateString;
      record["EndDate"] = recordEndDateString;
      dataColumnslist.forEach(columnProps => {
        //if many to many replace options
        if(columnProps.type == "manytomany") {
          let originalValue = combinedDataForms[index][columnProps.key];
          let options = columnProps.options;
          let switchedValues = this.switchManyToManyOptions(originalValue, options);
          record[columnProps.label] = switchedValues;
        }
        else {
          record[columnProps.label] = combinedDataForms[index][columnProps.key];
        }

      });

      data.push(record);

      if (dateMode == "daily") {
        curdate.setDate(curdate.getDate() + 1);
      }
      else if (dateMode == "monthly") {
        curdate.setMonth(curdate.getMonth() + 1);
      }
      index++;
    }

    let requiredList = dataColumnslist.filter(dataColumnItem => {
      return dataColumnItem.required;
    }).map(dataColumnItem => {
      return dataColumnItem.label
    });

    var ws = XLSX.utils.json_to_sheet(data);
    for (var i in ws) {
      if (typeof ws[i] == 'object') {

        // styling for all cells
        ws[i].s = {
          font: {
            bold: false
          },
          fill: {
            patternType: 'solid',
            fgColor: { rgb: 'ffffff' },
            bgColor: { rgb: 'ffffff' },
          },
          border: {
            top: {
              style: 'thin',
              color: { rgb: 'd4d4d4' }
            },
            bottom: {
              style: 'thin',
              color: { rgb: 'd4d4d4' }
            },
            right: {
              style: 'thin',
              color: { rgb: 'd4d4d4' }
            },
            left: {
              style: 'thin',
              color: { rgb: 'd4d4d4' }
            }
          },
        };

        let cell = XLSX.utils.decode_cell(i);
        if (cell.r == 0 && requiredList.includes(ws[i].v)) {
          // first row
          ws[i].s.font.bold = true;
          ws[i].s.fill.bgColor = { rgb: 'cccccc' };
          ws[i].s.fill.fgColor = { rgb: 'cccccc' };
        }
      }
    }

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, finalFilename);
  }

  daysBetweenDates(date1, date2) {
    // Convert both dates to milliseconds
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();

    // Calculate the difference in milliseconds
    var difference_ms = Math.abs(date2_ms - date1_ms);

    // Convert the difference to days
    var difference_days = Math.ceil(difference_ms / (1000 * 3600 * 24));

    return difference_days;
  }

  //Generates mutli well template
  public generateTemplateMultiWell(wellDetailsList: WellDetailsModel[], beginDate: Date, endDate: Date, dateMode: string, tableName: string, dataColumnslist: any[], combinedDataForms: any[]) {

    function formatDate(date) {
      let d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      let year = '' + d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [month, day, year].join('/');
    }

    var beginDateString = formatDate(beginDate);
    var endDateString = formatDate(endDate);
    var finalFilename = tableName + "_multiwell_" + beginDateString + "_" + endDateString + "_" + dateMode + ".xlsx";
    var workbook = XLSX.utils.book_new();
    var data = [];



    for (let wellIndex = 0; wellIndex < wellDetailsList.length; wellIndex++) {

      let wellDetails = wellDetailsList[wellIndex];

      var curdate = new Date(beginDate);
      var firstRecord = true;
      while (curdate <= endDate) {

        var curEndDate = null;

        if (dateMode == "monthly") {
          curEndDate = new Date(curdate);
          curEndDate.setMonth(curEndDate.getMonth() + 1);
          curEndDate.setDate(0);
        }
        else if (dateMode == "daily") {
          curEndDate = new Date(curdate);
        }

        var record = {};

        //Fill in the well header rows for all rows, not just the first one for each well.
        record["UIC Number"] = wellDetails.Uicnumber;
        record["Lease Name"] = wellDetails.LeaseName;
        record["Well Number"] = wellDetails.WellNumber;
        record["BEGWellId"] = wellDetails.Id;

        /*if (firstRecord) {
          record["UIC Number"] = wellDetails.Uicnumber;
          record["Lease Name"] = wellDetails.LeaseName;
          record["Well Number"] = wellDetails.WellNumber;
          record["BEGWellId"] = wellDetails.Id;
          firstRecord = false;
        }
        else {
          record["UIC Number"] = null;
          record["Lease Name"] = null;
          record["Well Number"] = null;
          record["BEGWellId"] = null;
        }*/



        var recordDateString = formatDate(curdate);
        var recordEndDateString = formatDate(curEndDate);

        record["Date"] = recordDateString;
        record["EndDate"] = recordEndDateString;

        //validate that the combinedDataForms has content
        let dataFormHasContent = combinedDataForms !== null && combinedDataForms.length !== 0 && combinedDataForms[wellIndex].length !== 0;
        dataColumnslist.forEach(columnProps => {
          //only record value if data column should persist in template
          if (dataFormHasContent) {
            record[columnProps.label] = columnProps.persist ? combinedDataForms[wellIndex][columnProps.key] : '';
          } else {
            //when data form has no content see record to empty string so column will appear in excel template
            record[columnProps.label] = '';
          }
        });

        data.push(record);

        if (dateMode == "daily") {
          curdate.setDate(curdate.getDate() + 1);
        }
        else if (dateMode == "monthly") {
          curdate.setMonth(curdate.getMonth() + 1);
        }
      }

      //add empty space between wells *disabled for now*
      //data.push({});

    }


    let requiredList = dataColumnslist.filter(dataColumnItem => {
      return dataColumnItem.required;
    }).map(dataColumnItem => {
      return dataColumnItem.label
    });

    let numberOfRecordsPerWell = this.daysBetweenDates(beginDate, endDate);

    var ws = XLSX.utils.json_to_sheet(data);
    for (var i in ws) {
      if (typeof ws[i] == 'object') {

        // styling for all cells
        ws[i].s = {
          font: {
            bold: false
          },
          fill: {
            patternType: 'solid',
            fgColor: { rgb: 'ffffff' },
            bgColor: { rgb: 'ffffff' },
          },
          border: {
            top: {
              style: 'thin',
              color: { rgb: 'd4d4d4' }
            },
            bottom: {
              style: 'thin',
              color: { rgb: 'd4d4d4' }
            },
            right: {
              style: 'thin',
              color: { rgb: 'd4d4d4' }
            },
            left: {
              style: 'thin',
              color: { rgb: 'd4d4d4' }
            }
          },
        };

        let cell = XLSX.utils.decode_cell(i);
        if (cell.r == 0 && requiredList.includes(ws[i].v)) {
          // first row
          ws[i].s.font.bold = true;
          ws[i].s.fill.bgColor = { rgb: 'cccccc' };
          ws[i].s.fill.fgColor = { rgb: 'cccccc' };
        }
        if (Math.floor((cell.r - 1) / numberOfRecordsPerWell) % 2 == 1 && cell.r !== 0) {
          ws[i].s.fill.bgColor = { rgb: 'f2f2f2' };
          ws[i].s.fill.fgColor = { rgb: 'f2f2f2' };
        }
      }
    }

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, finalFilename);
  }

  protected switchManyToManyOptions(originalValues: any, options: Array<any>) {

    // If originalValues are empty return an empty string.
    if (originalValues == null) {
      return '';
    }

    let originalParts = [];

    if(originalValues.split != null) {
      originalParts = originalValues.split(',');
    }
    else if(originalValues instanceof Array) {
      originalParts = originalValues;
    }
        
    let finalParts = [];


    originalParts.forEach((origPart) => {

      for(let i=0; i < options.length; i++) {

        if(options[i].value == origPart) {
          finalParts.push(options[i].label);
          break;
        }
      }
    });

    let final = finalParts.join(",");

    return final;
  }
}
